import script from "./BookingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingPage.vue?vue&type=script&setup=true&lang=ts"

import "./BookingPage.vue?vue&type=style&index=0&id=85c4076c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85c4076c"]])

export default __exports__